import { OpenpanelService } from '../services/openpanel.service';
import { COUNTRIES } from './countries';
import { Component, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItineraryServiceService, DataService, BookingService, UserService, CarrierLogoService } from '../services/index'
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import countryData from './country.json';
import { Error, User } from '../models/index'
import { Base64 } from 'js-base64';
import { interval, Subscription } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import * as $ from 'jquery';
import * as moment from 'moment-timezone';
import mixpanel from 'mixpanel-browser';
import { FaroService } from '../services/faro.service';

@Component({
    selector: 'app-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.css'],
    standalone: false
})
export class PaymentsComponent implements OnInit {
  readonly fallbackPaymentOptions = ['mpesa', 'card'];
  readonly airtelPhonePattern = /^(?:254|\+254|0)(?:73\d{7}|75\d{7}|78\d{7}|10[0-2]\d{6})$/;
  countries: any = countryData;
  paytotalfare:any;
  private sub: any;
  bookingdetails:any;
  // flights
  flightdetails:any;
  flightSearchdetails:any;
  flightSearch:any;
  bookingData:any;
  remainingTime: number; // in milliseconds
  minutes: number = 0;
  seconds: number = 0;
  isExpired: boolean = false;
  private subscription: Subscription;


  payeeEmail:any;
  payeePhoneno:any;
  customerPhone:any;
  payeeFirstName:any;
  payeeLastName:any;
  payeeAddress:any;
  api_error:Error;
  isError:boolean=false;

  int2:any;
  started=0;
  passBaggage =[];
  passBaggageValue:any;
  selectedFlight:any
  flightAerocrsdetails:any;
  ifAdultBagSelected=0;
  ifChildBagSelected=0;
  // end Flights
  returndetails:any;
  bookingdata:any={};
  bookingdataReturn:any={};
  passengers:any=[];
  fsname:any;
  lsname:any;
  isdno:any;
  phoneno:any;
  country:any;
  residence:any;
  returnpassengers=[];
  formValidation=[];

  errorMessage:any;
  res:any;
  is_return:false;
  loading=false;
  paymentForm: UntypedFormGroup;
  submitted = false;
  formDataObj={}
  counts = { adult: 0, child: 0, infant: 0 };

  // ---- View helpers for the redesigned page (layout only; form controls and payment flow are unchanged) ----
  readonly nationalityOptions = COUNTRIES;
  readonly months = [
    { value: '01', label: 'January' }, { value: '02', label: 'February' }, { value: '03', label: 'March' },
    { value: '04', label: 'April' }, { value: '05', label: 'May' }, { value: '06', label: 'June' },
    { value: '07', label: 'July' }, { value: '08', label: 'August' }, { value: '09', label: 'September' },
    { value: '10', label: 'October' }, { value: '11', label: 'November' }, { value: '12', label: 'December' }
  ];
  showTripDetails = false;
  // ---- One traveller open at a time ----
  /** Id of the traveller card that is open (e.g. 'a0'). Defaults to the first traveller. */
  openTravellerId: string | null = null;

  private travellerControlNames(p: { id: string; s: string; primary: boolean }): string[] {
    const base = ['fname', 'lname', 'country', 'day_of_birth', 'month_of_birth', 'year_of_birth', 'gender'];
    const adult = p.s === 'a' ? ['title', 'idno'] : [];
    const contact = p.primary ? ['email', 'phoneno'] : [];
    return [...adult, ...base, ...contact].map(name => name + p.id).filter(name => !!this.paymentForm?.get(name));
  }

  isTravellerOpen(p: { id: string }): boolean {
    const list = this.passengerForms;
    if (list.length <= 1) {
      return true;
    }
    return (this.openTravellerId ?? list[0]?.id) === p.id;
  }

  isTravellerComplete(p: { id: string; s: string; primary: boolean }): boolean {
    const names = this.travellerControlNames(p);
    return names.length > 0 && names.every(name => this.paymentForm.get(name).valid);
  }

  travellerHasErrors(p: { id: string; s: string; primary: boolean }): boolean {
    return this.travellerControlNames(p).some(name => this.hasError(name));
  }

  get completedTravellers(): number {
    return this.passengerForms.filter(p => this.isTravellerComplete(p)).length;
  }

  /** "Mr John Doe · Kenya · 12 Mar 1990" for a collapsed, completed traveller. */
  travellerLine(p: { id: string; s: string }): string {
    const value = (name: string) => (this.paymentForm.get(name + p.id)?.value ?? '').toString().trim();
    const title = value('title');
    const name = [title ? title.charAt(0).toUpperCase() + title.slice(1) : '', value('fname'), value('lname')].filter(Boolean).join(' ');
    const country = this.nationalityOptions.find(c => c.code === value('country'))?.name || '';
    const month = this.months.find(m => m.value === value('month_of_birth'))?.label.slice(0, 3) || '';
    const dob = [value('day_of_birth'), month, value('year_of_birth')].filter(Boolean).join(' ');
    return [name, country, dob ? 'Born ' + dob : ''].filter(Boolean).join(' · ');
  }

  openTravellerCard(p: { id: string }): void {
    this.openTravellerId = p.id;
    this.scrollToTraveller(p.id);
  }

  /** "Save and continue": validate this traveller only, then move to the next one that still needs details. */
  saveTraveller(p: { id: string; s: string; primary: boolean }): void {
    const names = this.travellerControlNames(p);
    names.forEach(name => this.paymentForm.get(name).markAsTouched());
    if (!this.isTravellerComplete(p)) {
      this.focusFirstError();
      return;
    }
    const list = this.passengerForms;
    const index = list.findIndex(item => item.id === p.id);
    const next = [...list.slice(index + 1), ...list.slice(0, index)].find(item => !this.isTravellerComplete(item));
    if (next) {
      this.openTravellerId = next.id;
      this.scrollToTraveller(next.id, true);
      return;
    }
    // Everyone is done: close the cards and bring the payment choice into view.
    this.openTravellerId = '';
    setTimeout(() => document.querySelector('.pay-methods')?.scrollIntoView({ behavior: 'smooth', block: 'center' }));
  }

  canCopyNationality(p: { id: string }): boolean {
    const primary = this.paymentForm?.get('countrya0')?.value;
    return !!primary && this.paymentForm.get('country' + p.id)?.value !== primary;
  }

  copyNationality(p: { id: string }): void {
    this.paymentForm.get('country' + p.id)?.setValue(this.paymentForm.get('countrya0')?.value);
  }

  private scrollToTraveller(id: string, focusFirstField = false): void {
    setTimeout(() => {
      const card = document.getElementById('traveller-' + id);
      card?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (focusFirstField) {
        card?.querySelector<HTMLElement>('.pay-input')?.focus({ preventScroll: true });
      }
    });
  }

  /**
   * Desktop: the fare summary scrolls inside itself when it is taller than the screen.
   * After a payment method is picked (Airtel adds a field), bring Pay now back into view.
   */
  revealPayButton(): void {
    setTimeout(() => {
      const rail = document.querySelector<HTMLElement>('.pay-rail__sticky');
      if (rail && rail.scrollHeight > rail.clientHeight + 1) {
        rail.scrollTop = rail.scrollHeight;
      }
    });
  }

  private focusFirstError(): void {
    setTimeout(() => {
      // The Airtel number can sit in the fare summary (desktop), outside the form element, so look
      // across the page and skip the copy that is hidden for the current layout.
      const first = Array.from(document.querySelectorAll<HTMLElement>('.pay-page .pay-field--error .pay-input'))
        .find(el => el.offsetParent !== null);
      if (!first) {
        this.scrollToForm();
        return;
      }
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      first.focus({ preventScroll: true });
    });
  }

  /** Set when Pay is pressed with incomplete details; drives the "N fields need attention" notice. */
  missingFieldCount = 0;

  /** Pay was pressed with gaps: say how many, then take the traveller to the first one. */
  private showMissingFields(): void {
    const controls = this.paymentForm?.controls || {};
    this.missingFieldCount = Object.keys(controls).filter(name => controls[name].invalid).length;
    // Open the first traveller that still has gaps so the highlighted fields are on screen.
    const incomplete = this.passengerForms.find(p => !this.isTravellerComplete(p));
    if (incomplete) {
      this.openTravellerId = incomplete.id;
    }
    this.focusFirstError();
  }

  /** Count down the notice as fields are fixed, without re-counting on every keystroke elsewhere. */
  get remainingMissingFields(): number {
    if (!this.missingFieldCount) {
      return 0;
    }
    const controls = this.paymentForm?.controls || {};
    return Object.keys(controls).filter(name => controls[name].invalid).length;
  }

  /** Every traveller as one list, so the template renders a single form block per person. */
  get passengerForms(): { key: string; id: string; s: 'a' | 'c' | 'i'; position: number; label: string; hint: string; primary: boolean }[] {
    const groups: { s: 'a' | 'c' | 'i'; name: string; hint: string; list: any[] }[] = [
      { s: 'a', name: 'Adult', hint: '12 years or older', list: this.groupedPassengers?.adult || [] },
      { s: 'c', name: 'Child', hint: '2 to 11 years', list: this.groupedPassengers?.child || [] },
      { s: 'i', name: 'Infant', hint: 'Under 2 years', list: this.groupedPassengers?.infant || [] }
    ];
    const out = [];
    let position = 0;
    for (const group of groups) {
      group.list.forEach((_: any, index: number) => {
        position += 1;
        const id = `${group.s}${index}`;
        // Only render a block once its controls exist (they are created after the booking loads).
        if (!this.paymentForm?.get('fname' + id)) { return; }
        out.push({
          key: id,
          id,
          s: group.s,
          position,
          label: `${group.name} ${index + 1}`,
          hint: group.hint,
          primary: group.s === 'a' && index === 0
        });
      });
    }
    return out;
  }

  get travellerSummary(): string {
    const part = (count: number, one: string, many: string) => (count > 0 ? `${count} ${count === 1 ? one : many}` : '');
    return [
      part(this.counts.adult, 'Adult', 'Adults'),
      part(this.counts.child, 'Child', 'Children'),
      part(this.counts.infant, 'Infant', 'Infants')
    ].filter(Boolean).join(', ');
  }

  hasError(name: string): boolean {
    const control = this.paymentForm?.get(name);
    return !!control && control.touched && control.invalid;
  }

  showError(name: string, error: string): boolean {
    const control = this.paymentForm?.get(name);
    return !!control && control.touched && control.hasError(error);
  }

  /** One message for the three date-of-birth inputs. */
  dobError(id: string): string | null {
    const day = 'day_of_birth' + id;
    const month = 'month_of_birth' + id;
    const year = 'year_of_birth' + id;
    if (this.showError(day, 'required') || this.showError(month, 'required') || this.showError(year, 'required')) {
      return 'Enter the full date of birth.';
    }
    if (this.showError(day, 'pattern') || this.showError(year, 'pattern')) {
      return 'Use numbers only for day and year.';
    }
    if (this.showError(day, 'minlength') || this.showError(day, 'maxlength')) {
      return 'Day should be two digits, for example 07.';
    }
    if (this.showError(year, 'minlength') || this.showError(year, 'maxlength')) {
      return 'Year should be four digits, for example 1990.';
    }
    return null;
  }
  groupedPassengers:any = {};

  selectedPaymentMethod: string = 'mpesa';
  availablePaymentOptions: Array<{
    value: string;
    label: string;
    logo: string;
    type?: string;
    redirect?: boolean;
  }> = [];

  // Price mismatch handling
  showPriceMismatchModal: boolean = false;
  priceMismatchData: any = null;
  originalBookingData: any = null;

  // Error handling properties
  currentError: any = null;
  showErrorModal: boolean = false;

  // Promo discount handling
  promoDiscountData: any = null;
  showPromoModal: boolean = false;
  internalBookingReference: string = null;
  hasPromoOffer: boolean = false;
  promoRevealed: boolean = false;

  // Payment processing overlay
  isProcessingPayment: boolean = false;
  paymentError: string = null;
  paymentPrefilledFromAccount = false;

  constructor(
    private openpanel: OpenpanelService,
    private router: Router,
    private route: ActivatedRoute,
    private service:ItineraryServiceService,
    private bookingService:BookingService,
    private userService: UserService,
    private dataService:DataService,
    private locationStrategy: LocationStrategy,
    private _fb: UntypedFormBuilder,
    public carrierLogoService: CarrierLogoService,
    private faroService: FaroService
  ) { }

  /**
   * Read the payment payload carried in the /payments/:id URL segment.
   * The payload is a URL-safe Base64 of the {flight_data, passengers} JSON,
   * so any platform can deep-link straight into checkout. Returns null when
   * the segment is missing or is the legacy placeholder (not valid JSON).
   */
  private getPayloadFromUrl(): string | null {
    const raw = this.route.snapshot.paramMap.get('id');
    if (!raw) { return null; }
    try {
      JSON.parse(Base64.decode(raw));   // validate it's a real payload
      return raw;
    } catch {
      return null;
    }
  }

  ngOnInit() {
    window.scroll(0,0);


    this.dataService.returnPaymentValueChange.subscribe(message =>{
      // 1. In-memory payload (normal in-app navigation): fastest path.
      // 2. URL payload (:id) so a deep link from any platform lands a user
      //    straight on the payment page with the chosen flight.
      // 3. On-device fallback for a return visit.
      if (!message) {
        message = this.getPayloadFromUrl();
      }
      if (!message) {
        message = localStorage.getItem('freviewd');
      }
      if (!message) {
        this.router.navigate(['/']);
        return;
      }
      localStorage.setItem('freviewd', message);

      let encoded =JSON.parse(Base64.decode(message))
      console.log(encoded);
      this.isError= encoded.isError;
      this.bookingData=encoded.flight_data;
      this.availablePaymentOptions = this.resolvePaymentOptions(this.bookingData?.payment_options);
      this.ensureSelectedPaymentMethod();
      this.hasPromoOffer = !!this.bookingData?.promo_discount;
      this.flightSearchdetails=encoded.flight_data;
      this.countPassengerTypes(this.flightSearchdetails.passengers);
      this.groupPassengersByType(this.flightSearchdetails.passengers)
      // let ex_at = new Date(this.flightSearchdetails.expires_at);
      // let cr_at = new Date(this.flightSearchdetails.created_at);
      // this.remainingTime = ex_at.getTime() - cr_at.getTime();

        // Parse the expires_at time in UTC−3
        const ex_at_utc_minus_3 = moment.tz(this.flightSearchdetails.expires_at, 'Etc/GMT+0');
      

        // Convert to Nairobi time (UTC+3)
        const ex_at_nairobi = ex_at_utc_minus_3.clone().tz('Africa/Nairobi');
    
        // Get the current Nairobi time
        const cr_at = moment.tz(new Date(), 'Africa/Nairobi');

        this.remainingTime = ex_at_nairobi.valueOf() - cr_at.valueOf();

    
        // Calculate the remaining time in milliseconds

      if (this.remainingTime <= 0) {
        this.isExpired = true;
        // this.triggerExpiration()
      } else {
        this.startCountdown();
      }
     
      // this.checkFlight(this.flightSearchdetails)

      if(this.groupedPassengers.adult.length > 0){
        for (let seat = 0; seat < this.groupedPassengers.adult.length; seat++) {
          let fsname='fname'+'a'+seat;
          let lsname='lname'+'a'+seat;
          let isdno='idno'+'a'+seat;
          let gender='gender'+'a'+seat;
          let title='title'+'a'+seat;
          let country = 'country'+ 'a'+ seat;
          let day_of_birth = 'day_of_birth'+ 'a'+ seat;
          let month_of_birth = 'month_of_birth'+ 'a'+ seat;
          let year_of_birth = 'year_of_birth'+ 'a'+ seat;


          if(seat == 0){
            let email='email'+'a'+seat;
            let phoneno = 'phoneno'+'a'+ seat;
            this.formDataObj[email]=['', [Validators.required, Validators.email]];
            this.formDataObj[phoneno]=['', [Validators.required, Validators.minLength(10),Validators.pattern('^(?:254|\\+254|0)(7|1)[0-9]{8}$')]];
          }

            this.formDataObj[fsname]=['', [Validators.required,Validators.pattern('^[a-zA-Z]+$')]];
            this.formDataObj[lsname]=['', [Validators.required,Validators.pattern('^[a-zA-Z]+$')]];
            this.formDataObj[isdno]=['', [Validators.required, Validators.minLength(7)]];
            this.formDataObj[gender]=['', Validators.required];
            this.formDataObj[title]=['', Validators.required];
            this.formDataObj[country]=['', Validators.required];
            this.formDataObj[day_of_birth]=['', [Validators.required,Validators.minLength(2),    Validators.pattern(/^[0-9]{2}$/),Validators.maxLength(2)]];
            this.formDataObj[month_of_birth]=['', [Validators.required]];
            this.formDataObj[year_of_birth]=['', [Validators.required,Validators.minLength(4),Validators.maxLength(4),Validators.pattern(/^[0-9]{4}$/)]];
          
          
        };
      }
      if(this.counts.child > 0){
        for (let seat = 0; seat < this.groupedPassengers.child.length; seat++) {  
          let fsname='fname'+'c'+seat;
          let lsname='lname'+'c'+seat;
          let gender='gender'+'c'+seat;
          let country = 'country'+ 'c'+ seat;
          let day_of_birth = 'day_of_birth'+ 'c'+ seat;
          let month_of_birth = 'month_of_birth'+ 'c'+ seat;
          let year_of_birth = 'year_of_birth'+ 'c'+ seat;
          this.formDataObj[fsname]=['', [Validators.required,Validators.pattern('^[a-zA-Z]+$')]];
          this.formDataObj[lsname]=['', [Validators.required,Validators.pattern('^[a-zA-Z]+$')]];
          this.formDataObj[day_of_birth]=['', [Validators.required,Validators.minLength(2),Validators.maxLength(2)]];
          this.formDataObj[gender]=['', Validators.required];
          this.formDataObj[month_of_birth]=['', [Validators.required]];
          this.formDataObj[year_of_birth]=['', [Validators.required,Validators.minLength(4),Validators.maxLength(4)]];
          
          this.formDataObj[country]=['', Validators.required];
        };
      }
      if(this.counts.infant > 0){
        for (let seat = 0; seat < this.groupedPassengers.infant.length; seat++) { 
            let fsname='fname'+'i'+seat;
            let lsname='lname'+'i'+seat;
            let gender='gender'+'i'+seat;
            let country = 'country'+ 'i'+ seat;
            let day_of_birth = 'day_of_birth'+ 'i'+ seat;
            let month_of_birth = 'month_of_birth'+ 'i'+ seat;
            let year_of_birth = 'year_of_birth'+ 'i'+ seat;
            this.formDataObj[fsname]=['', [Validators.required,Validators.pattern('^[a-zA-Z]+$')]];
            this.formDataObj[lsname]=['', [Validators.required,Validators.pattern('^[a-zA-Z]+$')]];
            this.formDataObj[gender]=['', Validators.required];
            this.formDataObj[day_of_birth]=['', [Validators.required,Validators.minLength(2),Validators.maxLength(2)]];
            this.formDataObj[month_of_birth]=['', [Validators.required]];
            this.formDataObj[year_of_birth]=['', [Validators.required,Validators.minLength(4),Validators.maxLength(4)]];
          
            this.formDataObj[country]=['', Validators.required];
          };
      }


      // this.bookingdetails = JSON.parse(Base64.decode(encoded.travel));
      
      
    });

    this.formDataObj['airtelPhone'] = [''];
    this.paymentForm =this._fb.group(this.formDataObj);
    this.syncPaymentMethodControls();
    this.prefillLeadPassengerFromAccount();
  }

  ngAfterViewInit() {
  }

  startCountdown() {
    this.subscription = interval(1000).pipe(
      takeWhile(() => this.remainingTime > 0), // Stop when time reaches 0
      map(() => {
        this.remainingTime -= 1000; // Subtract 1 second (1000ms)
        this.minutes = Math.floor((this.remainingTime / 1000) / 60);
        this.seconds = Math.floor((this.remainingTime / 1000) % 60);

        //track if 5 mins left
        if (this.minutes === 5) {
          mixpanel.track('Session 5 Minutes Expiration', {
            'booking_reference': this.bookingData.booking_reference,
            'payment_method': this.selectedPaymentMethod,
            'amount': this.bookingData.total_amount,
            'currency': this.bookingData.currency
          });
        }

        if (this.remainingTime <= 0) {
          this.triggerExpiration();
        }
      })
    ).subscribe();
  }

  triggerExpiration() {
    mixpanel.track('Session Expiration', {
      'booking_reference': this.bookingData.booking_reference,
      'payment_method': this.selectedPaymentMethod,
      'amount': this.bookingData.total_amount,
      'currency': this.bookingData.currency
    });
    this.isExpired = true;
    $('#sessionExpired').click();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  cancelModal() {
    mixpanel.track('Session Canceled', {
      'booking_reference': this.bookingData.booking_reference,
      'payment_method': this.selectedPaymentMethod,
      'amount': this.bookingData.total_amount,
      'currency': this.bookingData.currency
    });
    $('#dismissModal').click();
    this.router.navigate(['/']);
  }

  closePopup() {
    mixpanel.track('Session Refreshed', {
      'booking_reference': this.bookingData.booking_reference,
      'payment_method': this.selectedPaymentMethod,
      'amount': this.bookingData.total_amount,
      'currency': this.bookingData.currency
    });

    $('#dismissModal').click();
    this.router.navigate(['/booking']); // Navigate to /booking
  }

  countPassengerTypes(passengers) {
    passengers.forEach(passenger => {
      this.counts[passenger.type]++;
    });
  }

  groupPassengersByType(passengers) {
    this.groupedPassengers = passengers.reduce((acc, passenger) => {
      if (!acc[passenger.type]) {
        acc[passenger.type] = [];
      }
      acc[passenger.type].push(passenger);
      return acc;
    }, {});
  }

  counter(i: number) {
    return new Array(i);
}








  get f() { return this.paymentForm.controls; }


  checkIfArray(arr){
    return  Array.isArray(arr)
   }


calculateAgeFromBirthday(dateOfBirth) {
    let yearOfBirth = dateOfBirth.split("-"),
      currentYear = new Date().getFullYear();
    yearOfBirth = new Date(
      yearOfBirth[0],
      yearOfBirth[1] - 1,
      yearOfBirth[2]
    ).getFullYear();
    yearOfBirth = currentYear - yearOfBirth;
    return yearOfBirth;
  }


  setPaymentMethod(method: string): void {
    this.selectedPaymentMethod = method;
    this.paymentError = null;
    this.syncPaymentMethodControls();
  }

  private ensureSelectedPaymentMethod(): void {
    const availableMethods = this.availablePaymentOptions.map(option => option.value);

    if (!availableMethods.length) {
      this.availablePaymentOptions = this.resolvePaymentOptions(null);
      this.selectedPaymentMethod = this.availablePaymentOptions[0]?.value || 'mpesa';
      this.syncPaymentMethodControls();
      return;
    }

    if (!availableMethods.includes(this.selectedPaymentMethod)) {
      this.selectedPaymentMethod = this.availablePaymentOptions[0].value;
    }

    this.syncPaymentMethodControls();
  }

  private resolvePaymentOptions(paymentOptions: any): Array<{
    value: string;
    label: string;
    logo: string;
    type?: string;
    redirect?: boolean;
  }> {
    const defaults = this.fallbackPaymentOptions
      .map(method => this.buildPaymentOption(method))
      .filter(Boolean);

    if (!paymentOptions) {
      return defaults;
    }

    let resolved: Array<{
      value: string;
      label: string;
      logo: string;
      type?: string;
      redirect?: boolean;
    }> = [];

    if (Array.isArray(paymentOptions)) {
      resolved = paymentOptions
        .map(option => this.normalizePaymentOptionEntry(option))
        .filter(Boolean);
    } else if (typeof paymentOptions === 'object') {
      const nestedOptions = paymentOptions.options || paymentOptions.methods || paymentOptions.available;

      if (Array.isArray(nestedOptions)) {
        resolved = nestedOptions
          .map(option => this.normalizePaymentOptionEntry(option))
          .filter(Boolean);
      } else {
        resolved = Object.entries(paymentOptions)
          .map(([key, value]) => this.normalizePaymentOptionObjectEntry(key, value))
          .filter(Boolean);
      }
    }

    const deduped = resolved.filter((option, index, all) =>
      all.findIndex(candidate => candidate.value === option.value) === index
    );

    return deduped.length ? deduped : defaults;
  }

  private normalizePaymentOptionEntry(option: any) {
    if (typeof option === 'string') {
      return this.buildPaymentOption(option);
    }

    if (!option || typeof option !== 'object') {
      return null;
    }

    const method = option.code || option.value || option.name || option.slug || option.method || option.payment_method;
    return this.buildPaymentOption(method, option);
  }

  private normalizePaymentOptionObjectEntry(key: string, value: any) {
    if (value === false || value === null || value === undefined) {
      return null;
    }

    if (value === true) {
      return this.buildPaymentOption(key);
    }

    if (typeof value === 'string') {
      return this.buildPaymentOption(value, { code: key });
    }

    if (typeof value === 'object') {
      if (value.enabled === false || value.available === false || value.active === false) {
        return null;
      }

      return this.buildPaymentOption(
        value.code || value.value || value.name || value.slug || value.method || value.payment_method || key,
        value
      );
    }

    return null;
  }

  private buildPaymentOption(method: string, option: any = null) {
    const normalizedMethod = (method || '').toString().trim().toLowerCase();

    if (!normalizedMethod) {
      return null;
    }

    const knownOptions = {
      mpesa: {
        value: 'mpesa',
        label: 'Mpesa',
        logo: 'assets/img/brands/mpesa.jpg',
        type: 'mobile_money',
        redirect: false
      },
      card: {
        value: 'card',
        label: 'Card',
        logo: 'assets/img/brands/visa.jpg',
        type: 'card',
        redirect: true
      },
      airtel: {
        value: 'airtel',
        label: 'Airtel Money',
        logo: 'assets/img/brands/airtel.png',
        type: 'mobile_money',
        redirect: false
      }
    };

    const fallbackOption = {
      value: normalizedMethod,
      label: this.formatPaymentLabel(normalizedMethod),
      logo: option?.logo || option?.logo_url || '',
      type: option?.type || option?.channel || 'other',
      redirect: option?.redirect === true || option?.flow === 'redirect'
    };

    const knownOption = knownOptions[normalizedMethod] || fallbackOption;

    return {
      ...knownOption,
      label: option?.label || option?.display_name || knownOption.label,
      logo: option?.logo || option?.logo_url || knownOption.logo,
      type: option?.type || option?.channel || knownOption.type,
      redirect: option?.redirect === true || option?.flow === 'redirect' || knownOption.redirect
    };
  }

  private formatPaymentLabel(method: string): string {
    return method
      .split(/[_\-\s]+/)
      .filter(Boolean)
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  isRedirectPaymentMethod(): boolean {
    return !!this.availablePaymentOptions.find(
      option => option.value === this.selectedPaymentMethod && option.redirect
    );
  }

  isAirtelPaymentSelected(): boolean {
    return this.selectedPaymentMethod === 'airtel';
  }

  get airtelPhoneControl(): AbstractControl | null {
    return this.paymentForm?.get('airtelPhone') || null;
  }

  private getAuthenticatedUser(): User | null {
    this.userService.restoreAuthStateFromStorage();
    const authUser = this.userService.getCurrentUser();

    if (!authUser) {
      return null;
    }

    return new User().deserialize(authUser);
  }

  private normalizePrimaryPhoneForForm(phone: string | undefined): string {
    const digits = (phone || '').replace(/\D/g, '');

    if (!digits) {
      return '';
    }

    if (digits.startsWith('254') && digits.length >= 12) {
      return `0${digits.slice(3, 12)}`;
    }

    if (digits.startsWith('0')) {
      return digits.slice(0, 10);
    }

    if ((digits.startsWith('7') || digits.startsWith('1')) && digits.length === 9) {
      return `0${digits}`;
    }

    return digits;
  }

  private prefillLeadPassengerFromAccount(): void {
    if (!this.paymentForm || !this.groupedPassengers?.adult?.length) {
      return;
    }

    const user = this.getAuthenticatedUser();

    if (!user) {
      this.paymentPrefilledFromAccount = false;
      return;
    }

    const patch: Record<string, string> = {};

    const assignIfEmpty = (controlName: string, value?: string) => {
      const control = this.paymentForm.get(controlName);
      const normalizedValue = (value || '').trim();

      if (!control || !normalizedValue || control.value) {
        return;
      }

      patch[controlName] = normalizedValue;
    };

    assignIfEmpty('fnamea0', user.first_name);
    assignIfEmpty('lnamea0', user.last_name);
    assignIfEmpty('idnoa0', user.id_number);
    assignIfEmpty('emaila0', user.email);
    assignIfEmpty('phonenoa0', this.normalizePrimaryPhoneForForm(user.phone_number));

    if (!Object.keys(patch).length) {
      this.paymentPrefilledFromAccount = false;
      return;
    }

    this.paymentForm.patchValue(patch, { emitEvent: false });
    this.paymentPrefilledFromAccount = true;
  }

  private syncPaymentMethodControls(): void {
    const airtelPhoneControl = this.paymentForm?.get('airtelPhone');

    if (!airtelPhoneControl) {
      return;
    }

    if (this.isAirtelPaymentSelected()) {
      airtelPhoneControl.setValidators([
        Validators.required,
        Validators.pattern(this.airtelPhonePattern)
      ]);
    } else {
      airtelPhoneControl.clearValidators();
      airtelPhoneControl.setValue('', { emitEvent: false });
      airtelPhoneControl.setErrors(null);
      airtelPhoneControl.markAsPristine();
      airtelPhoneControl.markAsUntouched();
    }

    airtelPhoneControl.updateValueAndValidity({ emitEvent: false });
  }

  private normalizeKenyanPhoneNumber(phone: string): string {
    const digits = (phone || '').replace(/\D/g, '');

    if (digits.startsWith('254')) {
      return digits;
    }

    if (digits.startsWith('0')) {
      return `254${digits.slice(1)}`;
    }

    return digits;
  }

  private resolvePaymentCustomerPhone(formValue: any, primaryPhone: string): string {
    if (this.isAirtelPaymentSelected()) {
      return this.normalizeKenyanPhoneNumber(formValue?.airtelPhone || '');
    }

    return primaryPhone;
  }

  getPaymentErrorTitle(): string {
    if (this.isAirtelPaymentSelected()) {
      return 'Airtel Money Payment Failed';
    }

    if (this.selectedPaymentMethod === 'mpesa') {
      return 'M-Pesa Payment Failed';
    }

    if (this.selectedPaymentMethod === 'card') {
      return 'Card Payment Failed';
    }

    return 'Payment Failed';
  }

  getPaymentErrorTips(): string[] {
    if (this.isAirtelPaymentSelected()) {
      return [
        'Confirm the Airtel Money number is correct and registered for Airtel Money.',
        'Make sure the line is active and can receive a payment prompt right now.',
        'Check that the wallet has enough balance, then retry the payment.'
      ];
    }

    if (this.selectedPaymentMethod === 'mpesa') {
      return [
        'Confirm the phone number is correct and can receive an M-Pesa prompt.',
        'Check that the M-Pesa wallet has enough balance.',
        'Retry the payment or switch to another payment method if needed.'
      ];
    }

    return [
      'Review the payment details and retry the transaction.',
      'Check with your bank or provider if the payment keeps failing.',
      'Use another payment method if the issue persists.'
    ];
  }

  getPaymentMethodIconClass(method: string | undefined): string {
    const normalizedMethod = (method || '').toLowerCase();

    if (normalizedMethod === 'mpesa' || normalizedMethod === 'airtel') {
      return 'fa fa-mobile-alt';
    }

    return 'fa fa-credit-card';
  }

  handlePriceMismatch(errorData: any): void {
    mixpanel.track('Price Mismatch', {
      'booking_reference': this.bookingData.booking_reference,
      'payment_method': this.selectedPaymentMethod,
      'amount': this.bookingData.total_amount,
      'currency': this.bookingData.currency,
      'failure_reason_code': errorData?.code,
      'failure_reason': 'pricing_mismatch'
    });
    this.priceMismatchData = errorData.detail;
    this.showPriceMismatchModal = true;
    // $('#priceMismatchModal').modal('show');
    $('#priceMismatchBtn').click();
  }

  handleBookingError(errorData: any): void {
    // getErrorConfig() only builds UI copy (icon/title/message/actions) - it
    // never carried the raw code/detail through, so error_code below was
    // always undefined. Attach them here instead of touching every switch
    // case in getErrorConfig().
    this.currentError = { ...this.getErrorConfig(errorData), code: errorData?.code, detail: errorData?.detail };
    this.showErrorModal = true;
    // $('#bookingErrorModal').modal('show');
    $('#bookingErrorhBtn').click();


  }

  getErrorConfig(errorData: any): any {
    const errorCode = errorData.code;
    const errorTitle = errorData.title;

    switch (errorCode) {
      case 1001:
        return {
          icon: 'fa-exclamation-triangle',
          iconColor: '#ff6b6b',
          title: 'Invalid Booking Reference',
          message: 'The booking reference you provided is invalid or has expired. Please start a new search.',
          primaryAction: 'Search Again',
          primaryActionColor: '#007bff',
          secondaryAction: 'Contact Support',
          showSecondaryAction: true
        };

      case 1002:
        return {
          icon: 'fa-clock',
          iconColor: '#ff9500',
          title: 'Offer Expired',
          message: 'This flight offer has expired. Flight prices and availability change frequently. Please search again for current options.',
          primaryAction: 'Search Again',
          primaryActionColor: '#007bff',
          secondaryAction: 'View Similar Flights',
          showSecondaryAction: true
        };

      case 1005:
        return {
          icon: 'fa-wifi',
          iconColor: '#6c757d',
          title: 'Connection Timeout',
          message: 'We\'re experiencing connectivity issues with the airline system. This is temporary and usually resolves quickly.',
          primaryAction: 'Try Again',
          primaryActionColor: '#28a745',
          secondaryAction: 'Contact Support',
          showSecondaryAction: true
        };

      case 1006:
        return {
          icon: 'fa-shield-alt',
          iconColor: '#dc3545',
          title: 'Authentication Failed',
          message: 'We couldn\'t verify your booking with the airline. This might be a temporary issue with the airline\'s system.',
          primaryAction: 'Try Again',
          primaryActionColor: '#007bff',
          secondaryAction: 'Contact Support',
          showSecondaryAction: true
        };

      case 1007:
        return {
          icon: 'fa-credit-card',
          iconColor: '#dc3545',
          title: 'Payment Failed',
          message: 'Your payment could not be processed. Please check your payment details and try again, or use a different payment method.',
          primaryAction: 'Try Different Payment',
          primaryActionColor: '#007bff',
          secondaryAction: 'Contact Bank',
          showSecondaryAction: true
        };

      case 1008:
        return {
          icon: 'fa-edit',
          iconColor: '#ffc107',
          title: 'Invalid Information',
          message: 'Some of the information provided is invalid or incomplete. Please review your details and try again.',
          primaryAction: 'Review Details',
          primaryActionColor: '#007bff',
          secondaryAction: null,
          showSecondaryAction: false
        };

      case 1009:
        return {
          icon: 'fa-times-circle',
          iconColor: '#dc3545',
          title: 'Booking Failed',
          message: 'We couldn\'t complete your booking due to an issue with the airline system. Your payment has not been charged.',
          primaryAction: 'Try Again',
          primaryActionColor: '#007bff',
          secondaryAction: 'Contact Support',
          showSecondaryAction: true
        };

      case 1011:
        return {
          icon: 'fa-key',
          iconColor: '#dc3545',
          title: 'Session Expired',
          message: 'Your session has expired for security reasons. Please start a new search to continue with your booking.',
          primaryAction: 'Start New Search',
          primaryActionColor: '#007bff',
          secondaryAction: null,
          showSecondaryAction: false
        };

      case 1012: {
        // detail is an object for this code: { message, existing_booking_reference, rebook_allowed_after }
        const detail = errorData.detail || {};
        let message = detail.message || 'A similar booking already exists for these passengers on the same flight(s).';
        if (detail.existing_booking_reference) {
          message += ` Your existing booking reference is ${detail.existing_booking_reference}.`;
        }
        if (detail.rebook_allowed_after) {
          const rebookTime = new Date(detail.rebook_allowed_after);
          if (!isNaN(rebookTime.getTime())) {
            message += ` You can rebook after ${rebookTime.toLocaleString('en-GB', {
              day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
            })}.`;
          }
        }
        return {
          icon: 'fa-clone',
          iconColor: '#ff9500',
          title: 'Duplicate Booking',
          message: message,
          primaryAction: 'OK',
          primaryActionColor: '#007bff',
          secondaryAction: 'Contact Support',
          showSecondaryAction: true
        };
      }

      case 2000:
        return {
          icon: 'fa-server',
          iconColor: '#6c757d',
          title: 'System Error',
          message: 'We\'re experiencing technical difficulties. Our team has been notified and is working to resolve this issue.',
          primaryAction: 'Try Again Later',
          primaryActionColor: '#007bff',
          secondaryAction: 'Contact Support',
          showSecondaryAction: true
        };

      default:
        return {
          icon: 'fa-exclamation-circle',
          iconColor: '#dc3545',
          title: 'Booking Error',
          message: errorData.detail || errorTitle || 'An unexpected error occurred. Please try again or contact support.',
          primaryAction: 'Try Again',
          primaryActionColor: '#007bff',
          secondaryAction: 'Contact Support',
          showSecondaryAction: true
        };
    }
  }

  handleErrorPrimaryAction(): void {
    mixpanel.track('Booking Error', {
      'booking_reference': this.bookingData.booking_reference,
      'payment_method': this.selectedPaymentMethod,
      'amount': this.bookingData.total_amount,
      'currency': this.bookingData.currency,
      'error_code': this.currentError?.code,
      'error_title': this.currentError?.title,
      'error_detail': this.currentError?.detail,
      'failure_reason_code': this.currentError?.code,
      'failure_reason': this.currentError?.detail?.reason,
      'primary_action': this.currentError?.primaryAction
    });

    this.closeErrorModal();
    
    switch (this.currentError?.primaryAction) {
      case 'Search Again':
        this.router.navigate(['/booking']);
      case 'Start New Search':
        this.router.navigate(['/booking']);
        break;
      case 'Try Again':
        this.retryBooking();
        break;
      case 'Try Different Payment':
        this.router.navigate(['/booking']);
        break;
      case 'Review Details':
        // Scroll to form or highlight errors
        this.scrollToForm();
        break;
      case 'Try Again Later':
        this.router.navigate(['/']);
        break;
      case 'OK':
        // Duplicate booking — just dismiss; the existing booking still holds the itinerary
        break;
      default:
        this.router.navigate(['/booking']);
        break;
    }
  }

  handleErrorSecondaryAction(): void {
    this.closeErrorModal();
    
    switch (this.currentError?.secondaryAction) {
      case 'Contact Support':
        this.router.navigate(['/contact-us']);
        break;
      case 'View Similar Flights':
        this.router.navigate(['/']);
        break;
      case 'Contact Bank':
        // Could open a modal with bank contact info or external link
        window.open('tel:+254700000000', '_self');
        break;
      default:
        this.router.navigate(['/contact-us']);
        break;
    }
  }

  closeErrorModal(): void {
    this.showErrorModal = false;
    $('#dismissErrorModal').click();
    this.currentError = null;
  }

  retryBooking(): void {
    // Retry the same booking request
    this.submitForm();
  }

  scrollToForm(): void {
    // Scroll to the form section
    const formElement = document.getElementById('ngFormPayment');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  acceptPriceChange(): void {
    this.showPriceMismatchModal = false;
    $('#dismissPriceModal').click();
    
    // Update the booking data with new price
    if (this.priceMismatchData) {
      this.bookingData.total_amount = this.priceMismatchData.new;
      this.resubmitWithPriceConsent();
    }
  }

  rejectPriceChange(): void {
    this.showPriceMismatchModal = false;
    $('#dismissPriceModal').click();
    this.router.navigate(['/booking']);
  }

  resubmitWithPriceConsent(): void {
    if (!this.priceMismatchData) return;

    this.loading = true;
    this.isError = false;

    // Rebuild booking data with price consent
    let bookData = {
      'passengers': this.passengers,
      "offer_id": this.bookingData.offer_id,
      "result_id": this.bookingData.result_id,
      "payments": {
        "type": "hold",
        "currency": "KES",
        "amount": this.priceMismatchData.new
      },
      "customer": {
        "phone_number": this.customerPhone,
        "email": this.payeeEmail,
        "first_name": this.payeeFirstName,
        "last_name": this.payeeLastName,
        "address": this.payeeAddress
      },
      "gds": this.bookingData.gds,
      "price_change_consent": {
        "value": true,
        "identifier": this.priceMismatchData.identifier
      }
    };

    this.service.holdFlightBooking(bookData).subscribe({
      next: (data) => {
        this.res = data;
        this.loading = false;

        if (this.res.success === true) {
          this.internalBookingReference = this.res.data.internal_booking_reference;
          const promo = this.res.data.promo_discount;
          if (promo) {
            this.promoDiscountData = promo;
            this.showPromoModal = true;
            $('#promoDiscountBtn').click();
          } else {
            this.initiatePaymentRequest(this.internalBookingReference);
          }
        } else {
          this.isError = true;
          this.errorMessage = this.res.data?.message || "An error occurred during booking";
        }
      },
      error: (error) => {
        this.loading = false;
        this.isError = true;

        if (error.error?.success === false && error.error?.data?.errors) {
          const firstError = error.error.data.errors[0];

          if ([1001, 1002, 1005, 1006, 1007, 1008, 1009, 1011, 1012, 2000].includes(firstError?.code)) {
            this.handleBookingError(firstError);
            return;
          }

          this.isError = true;
          this.errorMessage = firstError?.detail || firstError?.title || "An error occurred";
          this.api_error = new Error().deserialize(error.error.data.errors);
        } else {
          this.isError = true;
          this.errorMessage = "Sorry there has been a technical problem. Please try again";
          this.api_error = error.error?.errors ? new Error().deserialize(error.error.errors) : null;
        }
      }
    });
  }
  

  initiatePaymentRequest(internalBookingReference: string): void {
    this.isProcessingPayment = true;
    this.paymentError = null;
    const paymentData = {
      "internal_booking_reference": internalBookingReference,
      "payment_method": this.selectedPaymentMethod
    };

    this.service.requestPayment(paymentData).subscribe({
      next: (data) => {
        if (data.success === true) {
          mixpanel.track('Initiate Payment Success', {
            'payment_method': this.selectedPaymentMethod,
            'amount': this.bookingData.total_amount,
            'currency': this.bookingData.currency,
            'booking_reference': internalBookingReference
          });

          if (this.isRedirectPaymentMethod()) {
            const redirect_url = data.data.redirect_payment_url || data.data.payment_details?.authorization_url;
            window.location.href = redirect_url;
          } else {
            let payee = {
              "booking_reference": internalBookingReference,
              "payments": this.selectedPaymentMethod,
              "amount": 1.0,
              "customer": {
                "phone_number": this.customerPhone,
                "email": this.payeeEmail,
                "first_name": this.payeeFirstName,
                "last_name": this.payeeLastName,
                "address": this.payeeAddress
              }
            };
            let others = {
              'data': data.data,
              'payee': payee,
              'seach_details': this.flightSearchdetails,
              'search_data': this.flightSearch,
              'booking_data': this.bookingData,
              'passengers': this.passengers,
              'promo_discount': this.promoDiscountData
            };
            this.isProcessingPayment = false;
            let f = Base64.encode(JSON.stringify(others));
            this.dataService.changeConfirmMessage(f);
            let cmmessage = btoa("Opps sory mate!");
            this.router.navigate(['/confirm-payments', cmmessage]);
          }
        } else {
          this.isProcessingPayment = false;
          const nextFirstError = data.data?.errors?.[0];
          this.paymentError = data.data?.message || nextFirstError?.detail || nextFirstError?.title || "An error occurred during payment. Please try again.";
          mixpanel.track('Initiate Payment Failed', {
            'payment_method': this.selectedPaymentMethod,
            'amount': this.bookingData.total_amount,
            'currency': this.bookingData.currency,
            'booking_reference': internalBookingReference,
            'error': this.paymentError,
            'failure_reason_code': nextFirstError?.code,
            'failure_reason': nextFirstError?.detail?.reason
          });
        }
      },
      error: (error) => {
        this.isProcessingPayment = false;

        let errFirstError: any = null;
        if (error.error?.success === false && error.error?.data?.errors) {
          errFirstError = error.error.data.errors[0];
          this.paymentError = errFirstError?.detail || errFirstError?.title || "An error occurred. Please try again.";
        } else {
          this.paymentError = "Sorry, there has been a technical problem. Please try again.";
        }

        mixpanel.track('Initiate Payment Failed', {
          'payment_method': this.selectedPaymentMethod,
          'amount': this.bookingData.total_amount,
          'currency': this.bookingData.currency,
          'booking_reference': internalBookingReference,
          'error': this.paymentError,
          'failure_reason_code': errFirstError?.code,
          'failure_reason': errFirstError?.detail?.reason
        });
        $('#paymentErrorBtn').click();
      }
    });
  }

  retryPayment(): void {
    $('#dismissPaymentErrorModal').click();
    if (this.internalBookingReference) {
      this.initiatePaymentRequest(this.internalBookingReference);
    }
  }

  confirmPromoAndPay(): void {
    this.showPromoModal = false;
    this.paymentError = null;
    $('#dismissPromoModal').click();
    if (this.internalBookingReference) {
      this.initiatePaymentRequest(this.internalBookingReference);
    }
  }

  dismissPromoModal(): void {
    this.showPromoModal = false;
    $('#dismissPromoModal').click();
  }

  getPromoDiscountPercent(): number {
    if (!this.promoDiscountData || !this.bookingData?.total_amount) return 0;
    return Math.round((this.promoDiscountData.user.amount / this.bookingData.total_amount) * 100);
  }

  getPromoFinalAmount(): number {
    if (!this.promoDiscountData || !this.bookingData?.total_amount) return 0;
    return this.bookingData.total_amount - this.promoDiscountData.user.amount;
  }

  submitForm(){
    if (this.loading) {
      return;
    }
    if (this.isAirtelPaymentSelected() && this.airtelPhoneControl?.invalid) {
      this.airtelPhoneControl.markAsTouched();
      this.showMissingFields();
      return;
    }

    // If promo already revealed, go straight to payment
    if (this.promoRevealed && this.internalBookingReference) {
      this.initiatePaymentRequest(this.internalBookingReference);
      return;
    }

    this.submitted=true;
    if (!this.paymentForm.valid) {
      this.paymentForm.markAllAsTouched();
      this.showMissingFields();
      return;
    }
    this.missingFieldCount = 0;
    clearInterval(this.int2);

    let value = this.paymentForm.value;
    this.openpanel.track('payment_started', {
      amount: this.bookingData?.total_amount,
      currency: this.bookingData?.currency || 'KES'
    });
    this.faroService.pushEvent('passenger_details_submitted', {
      total_fare: this.bookingData?.total_amount,
      currency: this.bookingData?.currency || 'KES',
      payment_method: this.selectedPaymentMethod,
    });
    this.isError=false;
    this.loading=true;
    this.passengers=[];
    // Get adults details
    if(this.counts.adult > 0){

          for (let seat = 0; seat < this.groupedPassengers.adult.length; seat++) {
          let passenger={};
          
          let fsname='fname'+'a'+seat;
          let lsname='lname'+'a'+seat;
          let isdno='idno'+'a'+seat;
          let gender='gender'+'a'+seat;
          let title='title'+'a'+seat;
          let country = 'country'+ 'a'+ seat;
          let day_of_birth = 'day_of_birth'+ 'a'+ seat;
          let month_of_birth = 'month_of_birth'+ 'a'+ seat;
          let year_of_birth = 'year_of_birth'+ 'a'+ seat;
          
          if(seat == 0){
             let memail='email'+'a'+seat;
             let mphoneno = 'phoneno'+'a'+ seat;
             this.payeeEmail=value[memail]
             this.customerPhone='254' + value[mphoneno].slice(-9),
             this.payeePhoneno=value[mphoneno], 
             this.payeeFirstName=value[fsname]
             this.payeeLastName=value[lsname]
             this.payeeAddress=value[country]
          }

            passenger={
              "phone_number": this.payeePhoneno.slice(-9),
              "phone_code": "+254",
              "email": this.payeeEmail,
              "born_on": value[year_of_birth]+'-'+value[month_of_birth]+'-'+value[day_of_birth],
              "title": (value[title] == 'mr' ) ? 'Mr' : (value[title] == 'mrs' ) ? 'Mrs' : 'Miss',
              "gender": value[gender],
              "family_name": value[lsname]?.trim(),
              "given_name": value[fsname]?.trim(),
              "id_or_passport":value[isdno],
              "nationality":value[country],
              "type": "adult"
            }


      
         
      this.passengers.push(passenger);
    };
  }
      // get children details 
      if(this.counts.child > 0){
        for (let seat = 0; seat < this.groupedPassengers.child.length; seat++) {
        let passenger={};
        let fsname='fname'+'c'+seat;
        let lsname='lname'+'c'+seat;
        let isdno='idno'+'c'+seat;
        let gender='gender'+'c'+seat;
        let country = 'country'+'c'+ seat;
        let day_of_birth = 'day_of_birth'+'c'+ seat;
        let month_of_birth = 'month_of_birth'+'c'+ seat;
        let year_of_birth = 'year_of_birth'+'c'+ seat;

          passenger={
              "phone_number": this.payeePhoneno.slice(-9),
              "phone_code": "+254",
              "email": this.payeeEmail,
              "born_on": value[year_of_birth]+'-'+value[month_of_birth]+'-'+value[day_of_birth],
              "title": value[gender] === 'male' ? 'Mr' : 'Miss',
              "gender": value[gender],
              "family_name": value[lsname]?.trim(),
              "given_name": value[fsname]?.trim(),
              "id_or_passport":value[isdno],
              "nationality":value[country],
              "type": "child"
          }

          this.passengers.push(passenger);
    };
    }

          // get infant details 
          if(this.counts.infant > 0){

            for (let seat = 0; seat < this.groupedPassengers.infant.length; seat++) {
            let passenger={};
            let fsname='fname'+'i'+seat;
            let lsname='lname'+'i'+seat;
            let isdno='idno'+'i'+seat;
            let gender='gender'+'i'+seat;
            let country = 'country'+'i'+ seat;
            let day_of_birth = 'day_of_birth'+'i'+ seat;
            let month_of_birth = 'month_of_birth'+'i'+ seat;
            let year_of_birth = 'year_of_birth'+'i'+ seat;

            passenger={
                "phone_number": this.payeePhoneno.slice(-9),
                "phone_code": "+254",
                "email": this.payeeEmail,
                "born_on": value[year_of_birth]+'-'+value[month_of_birth]+'-'+value[day_of_birth],
                "title": value[gender] === 'male' ? 'Mr' : 'Miss',
                "gender": value[gender],
                "family_name": value[lsname]?.trim(),
                "given_name": value[fsname]?.trim(),
                "nationality":value[country],
                "id_or_passport":value[isdno],
                "type": "infant"
              }
  
          this.passengers.push(passenger);
        };
        }

    this.customerPhone = this.resolvePaymentCustomerPhone(value, this.customerPhone);

    let bookData = {
      'passengers': this.passengers,
      "offer_id": this.bookingData.offer_id,
      "result_id": this.bookingData.result_id,
      "payments": {
        "type": "hold",
        "currency": "KES",
        "amount": this.bookingData.total_amount
      },
      "customer":{
        "phone_number": this.customerPhone,
        "email": this.payeeEmail,
        "first_name": this.payeeFirstName,
        "last_name": this.payeeLastName,
        "address": this.payeeAddress
      },
      "gds":this.bookingData.gds
    }

    mixpanel.track('Initiate Payment', {
      'payment_method': this.selectedPaymentMethod,
      'amount': this.bookingData.total_amount,
      'currency': this.bookingData.currency,
      'customer_phone': this.customerPhone,
      'customer_email': this.payeeEmail,
      'customer_first_name': this.payeeFirstName,
      'customer_last_name': this.payeeLastName,
      'customer_address': this.payeeAddress
    });
    this.faroService.pushEvent('payment_submitted', {
      payment_method: this.selectedPaymentMethod,
      total_fare: this.bookingData.total_amount,
      currency: this.bookingData.currency,
    });






    this.loading=true;

      this.service.holdFlightBooking(bookData).subscribe({
        next: (data) => {
          this.res = data;
          this.loading = false;

          if (this.res.success === true) {
            this.internalBookingReference = this.res.data.internal_booking_reference;

            mixpanel.track('Hold Flight Success', {
              'payment_method': this.selectedPaymentMethod,
              'amount': this.bookingData.total_amount,
              'currency': this.bookingData.currency,
              'booking_reference': this.internalBookingReference
            });

            const promo = this.res.data.promo_discount;
            if (promo && this.hasPromoOffer && !this.promoRevealed) {
              // Reveal discount inline — don't auto-pay
              this.promoDiscountData = promo;
              this.promoRevealed = true;
            } else if (promo) {
              this.promoDiscountData = promo;
              this.showPromoModal = true;
              $('#promoDiscountBtn').click();
            } else {
              this.initiatePaymentRequest(this.internalBookingReference);
            }
          } else {
            const holdFirstError = this.res.data?.errors?.[0];
            mixpanel.track('Hold Flight Failed', {
              'payment_method': this.selectedPaymentMethod,
              'amount': this.bookingData.total_amount,
              'currency': this.bookingData.currency,
              'error': this.res.data?.message || "An error occurred during booking",
              'failure_reason_code': holdFirstError?.code,
              'failure_reason': holdFirstError?.detail?.reason
            });
            this.isError = true;
            this.errorMessage = this.res.data?.message || "An error occurred during booking";
          }
        },
        error: (error) => {
          this.loading = false;

          if (error.error?.success === false && error.error?.data?.errors) {
            const firstError = error.error.data.errors[0];

            if (firstError?.code === 1010 && firstError?.title === "Pricing Mismatch") {
              this.handlePriceMismatch(firstError);
              return;
            }

            if ([1001, 1002, 1005, 1006, 1007, 1008, 1009, 1011, 1012, 2000].includes(firstError?.code)) {
              this.handleBookingError(firstError);
              return;
            }

            this.isError = true;
            this.errorMessage = firstError?.detail || firstError?.title || "An error occurred";
            this.api_error = new Error().deserialize(error.error.data.errors);
          } else {
            this.isError = true;
            this.errorMessage = "Sorry there has been a technical problem. Please try again";
            if (error.error?.errors) {
              this.api_error = new Error().deserialize(error.error.errors);
            }
          }
        }
      });


  }

}
